import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Container";
import Col from "react-bootstrap/Container";
import ProductCard from "./ProductCard";
import LibraryFilter from "./LibraryFilter";
import ShareModal from "../share/ShareModal";


function LibraryScreen({ users, setUsers, items, itemClick, updateItems }) {
  const [libraryItems, setLibraryItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [showShare, setShowShare] = useState(false);
  const [currentItem, setCurrentItem] = useState({});
 

  const shareClick = (item) => {
    setShowShare(true);
    setCurrentItem(item);
  }

  const closeShare = () => setShowShare(false);
  
  /**
   * Set libraryItems to filteredItems on load to load initial set of data for use within productCards
   */
  useEffect(() => {
    
    setLibraryItems(items);
    updateFilteredItems(items);
  }, []);

  /**
   * Used by LibraryFilter, sets items to load within productCards
   * @param {*} items
   */
  function updateFilteredItems(ufiVal) {
    // Alphabetically sort items, and make sure expired items display last
    let goodItems = [];
    let expiredItems = [];
    ufiVal.forEach(item => {
      if(item.tag === 'expired'){
        expiredItems.push(item);
      }
      else{
        goodItems.push(item);
      }
    });
    goodItems.sort((a, b) => (a.title > b.title) ? 1 : -1);
    expiredItems.sort((a, b) => (a.title > b.title) ? 1 : -1);
    setFilteredItems(goodItems.concat(expiredItems));

  }

  function resetFilter(){
    updateFilteredItems(libraryItems);
  }


  const productCards = filteredItems.length !== 0 ? filteredItems.map( (item) => (<ProductCard item={item} itemClick={itemClick} openShare={shareClick} />) ) : (<div>No Library Items Found</div>);
  

  return (
    <Container>
      <Row className="filterbar">
        <Col>
          <LibraryFilter items={libraryItems} setItems={updateFilteredItems} resetFilter={resetFilter} />
        </Col>
      </Row>
      <Row className="grid">
        <Col className="productlist">{productCards}</Col>
      </Row>
      <ShareModal show={showShare} toggleShare={setShowShare} users={users} setUsers={setUsers} close={closeShare} item={currentItem} items={items} updateItems={updateItems} />
    </Container>
  );
}

export default LibraryScreen;
